import React from 'react'
import { Box, Typography } from '@mui/material'
import palette from '../../../../theme/palette'
import { OWNERS } from '../constants'
import { fmtDT, fmtHours } from '../eddBreachUtils'

const DOT = {
  FLAGGED: palette.warning.main,
  OPS: palette.primary.main,
  KAM: palette.warning.dark,
  REATTRIBUTED: palette.secondary.main,
  HANDBACK: palette.primary.main,
  DELIVERED: palette.success.main,
  CLOSED: palette.success.dark,
  REOPENED: palette.error.main,
  EXITED: palette.grey[500],
}

/**
 * Append-only journey, oldest first, with "held Nh under X" on every entry that carried an owner.
 * Each entry shows who acted: the name, and the member's login email looked up in the PTL team by `actorId`.
 */
export default function JourneyTimeline({ events = [], team = [] }) {
  if (!events.length) return <Typography variant='body2' color='text.secondary'>No history yet.</Typography>
  const emailOf = (id) => team.find((t) => t.id === id)?.email
  return (
    <Box>
      {events.map((e, i) => (
        <Box key={i} sx={{ display: 'flex', gap: 1.5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 0.75 }}>
            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: DOT[e.action] || palette.grey[500], flexShrink: 0 }} />
            {i < events.length - 1 && <Box sx={{ width: 2, flex: 1, bgcolor: palette.grey[300], my: 0.5 }} />}
          </Box>
          <Box sx={{ pb: 2, minWidth: 0 }}>
            <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>{fmtDT(e.ts)}</Typography>
            <Typography sx={{ fontSize: 12, fontWeight: 700 }}>{e.actorName}</Typography>
            {emailOf(e.actorId) && <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>{emailOf(e.actorId)}</Typography>}
            <Typography sx={{ fontSize: 12 }}>{e.label}</Typography>
            {e.detail && (
              <Typography sx={{ fontSize: 11.5, color: 'text.secondary', mt: 0.5, p: 1, bgcolor: palette.grey[100], borderRadius: 1, wordBreak: 'break-word' }}>
                {e.detail}
              </Typography>
            )}
            {e.owner && e.heldHrs > 0 && e.action !== 'CLOSED' && (
              <Typography sx={{ fontSize: 11, fontWeight: 600, color: OWNERS[e.owner]?.color, mt: 0.5 }}>
                Held {fmtHours(e.heldHrs)} under {OWNERS[e.owner]?.short}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  )
}
